import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import React from 'react'
import COLORS from 'lib/colors';

type ToggleButtonProps = {
  onClick: (e: React.MouseEvent) => void
  icon: React.ReactNode
  label?: string
  toggleOn: boolean
} & IconButtonProps

export default function ToggleButton({
  onClick, icon, label, toggleOn, ...props
}: ToggleButtonProps) {
  return (
    <IconButton
      aria-label={label}
      aria-pressed={toggleOn}
      onClick={onClick}
      sx={{
        width: '30px',
        height: '30px',
        backgroundColor: toggleOn ? `${COLORS.frenchBlue} !important` : 'white',
        color: toggleOn ? 'white' : COLORS.frenchBlue
      }}
      {...props}
    >
      {icon}
    </IconButton>
  )
}
